var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "other-method",
      attrs: { id: "other-method", name: "card-payment" }
    },
    [
      _c("div", { staticClass: "other-method__container" }, [
        _vm.oneClickProvider == "googlePay" ||
        _vm.oneClickProvider == "applePay"
          ? _c("header", [
              _c("div", { staticClass: "text" }, [
                _vm._v(_vm._s(_vm.$t("paywall.or")))
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "cards" }, [
          _c("img", {
            attrs: {
              src: _vm.mediaBaseUrl + "paywall/visa.svg",
              width: "48px",
              alt: "visa"
            }
          }),
          _vm._v(" "),
          _c("img", {
            attrs: {
              src: _vm.mediaBaseUrl + "paywall/mastercard.svg",
              width: "50px",
              alt: "mastercard"
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "other-method__form" }, [
          _c(
            "form",
            {
              staticClass: "form__content",
              attrs: { id: "card-subscription-form" }
            },
            [
              _c("label", [
                _c("span", [_vm._v(_vm._s(_vm.$t("paywall.form.nameTitle")))]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.userInfo.name,
                      expression: "userInfo.name"
                    }
                  ],
                  staticClass: "name",
                  attrs: {
                    placeholder: _vm.$t("paywall.form.namePlaceholder"),
                    name: "name",
                    type: "text",
                    required: ""
                  },
                  domProps: { value: _vm.userInfo.name },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.userInfo, "name", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("label", [
                _c("span", [_vm._v("Email")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.userInfo.email,
                      expression: "userInfo.email"
                    }
                  ],
                  staticClass: "name",
                  attrs: {
                    placeholder: "mail@example.com",
                    name: "email",
                    type: "email",
                    required: ""
                  },
                  domProps: { value: _vm.userInfo.email },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.userInfo, "email", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("label", [
                _c("span", [_vm._v(_vm._s(_vm.$t("paywall.form.address")))]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.userInfo.address,
                      expression: "userInfo.address"
                    }
                  ],
                  staticClass: "name",
                  attrs: {
                    placeholder: _vm.$t("paywall.form.address"),
                    name: "billing_address[line1]",
                    type: "text",
                    required: ""
                  },
                  domProps: { value: _vm.userInfo.address },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.userInfo, "address", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("label", [
                _c("span", [_vm._v(_vm._s(_vm.$t("paywall.form.cardTitle")))]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "stripe-input",
                  attrs: { id: "card-form" }
                })
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "submit-button",
                  on: {
                    click: function() {
                      return _vm.tracker.report(
                        "User_click_subscription_get_plan4"
                      )
                    }
                  }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("paywall.form.button")) +
                      "\n        "
                  )
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "protection-text" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("paywall.protectionText")) +
                    "\n        "
                )
              ])
            ]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }